import { Pipe, PipeTransform } from '@angular/core';
import { PartnerOption } from '../constant/partner-option';

@Pipe({
  name: 'partner'
})
export class PartnerPipe implements PipeTransform {

  transform(code: number | undefined): string | null | undefined {
    if (!code) {
      return null;
    }
    return PartnerOption.fromCode(code)?.name;
  }

}
